import { render, staticRenderFns } from "./MoveAndChatExportDialog.vue?vue&type=template&id=33c02b5d&scoped=true&"
import script from "./MoveAndChatExportDialog.vue?vue&type=script&lang=ts&"
export * from "./MoveAndChatExportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c02b5d",
  null
  
)

export default component.exports